import type { ConditionOperator } from "building-types/conditions/conditionTypes";
import type { DocEntityField } from "building-types/conditions/docEntityFieldTypeDefTypes";
import {
  DocEntityFieldTypeDefs,
  DocEntityFieldTypeDefOperators,
  DocEntityFieldTypeDefDefaultValues,
} from "building-types/conditions/docEntityFieldTypeDefTypes";
import type { Label } from "building-types/entities/labelTypes";
import type { Table } from "common/data/table";

export function collectEntityTypeDefs(labels: Table<Label>) {
  return { ...labels, ...DocEntityFieldTypeDefs };
}

export function entityFieldDefaultOperator(field: DocEntityField): ConditionOperator {
  return DocEntityFieldTypeDefOperators[field]?.[0] ?? "==";
}

export function entityFieldDefaultValue(field: string): string | number {
  return DocEntityFieldTypeDefDefaultValues[field] ?? "";
}
